const filterFiles = files =>
  files.filter(file => {
    if (file.children) file.children = filterFiles(file.children);
    if (file.children && file.children.length > 0) return true;

    return file.selected;
  });

export default filterFiles;



// WEBPACK FOOTER //
// ./src/utility/filterFiles.js